// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/fonts/JosefinSans-Regular.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'JosefinSans';
  src: local('JosefinSans'), url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
  font-display: swap;
}

body {
  min-height: 100%;
  margin: 0;
  border: 0;
  padding: 0;
  font-family: 'JosefinSans', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: #f3f4ff;
  background-repeat: no-repeat;
  background-attachment: fixed;
}

/* Responsividade para telas pequenas (celulares) */
@media only screen and (max-width: 600px) {
  body {
      font-size: 14px;
  }

  h1 {
      font-size: 22px;
  }

  h2 {
      font-size: 18px;
  }

  p {
      font-size: 12px;
  }

  /* Ajuste de largura para botões e links */
  button, a {
      font-size: 14px;
      width: 100%;
      text-align: center;
  }
}

/* Responsividade para tablets (entre 600px e 1024px) */
@media only screen and (max-width: 1024px) and (min-width: 601px) {
  body {
      font-size: 15px;
  }

  h1 {
      font-size: 26px;
  }

  h2 {
      font-size: 22px;
  }

  p {
      font-size: 14px;
  }

  /* Ajuste de largura para botões e links */
  button, a {
      font-size: 16px;
      width: auto;
  }
}

/* Responsividade para telas grandes (desktop e maiores) */
@media only screen and (min-width: 1025px) {
  body {
      font-size: 16px;
  }

  h1 {
      font-size: 30px;
  }

  h2 {
      font-size: 24px;
  }

  p {
      font-size: 16px;
  }

  button, a {
      font-size: 18px;
  }
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,qFAA2F;EAC3F,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,SAAS;EACT,UAAU;EACV,6KAA6K;EAC7K,mCAAmC;EACnC,kCAAkC;EAClC,mBAAmB;EACnB,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA,mDAAmD;AACnD;EACE;MACI,eAAe;EACnB;;EAEA;MACI,eAAe;EACnB;;EAEA;MACI,eAAe;EACnB;;EAEA;MACI,eAAe;EACnB;;EAEA,0CAA0C;EAC1C;MACI,eAAe;MACf,WAAW;MACX,kBAAkB;EACtB;AACF;;AAEA,uDAAuD;AACvD;EACE;MACI,eAAe;EACnB;;EAEA;MACI,eAAe;EACnB;;EAEA;MACI,eAAe;EACnB;;EAEA;MACI,eAAe;EACnB;;EAEA,0CAA0C;EAC1C;MACI,eAAe;MACf,WAAW;EACf;AACF;;AAEA,0DAA0D;AAC1D;EACE;MACI,eAAe;EACnB;;EAEA;MACI,eAAe;EACnB;;EAEA;MACI,eAAe;EACnB;;EAEA;MACI,eAAe;EACnB;;EAEA;MACI,eAAe;EACnB;AACF","sourcesContent":["@font-face {\n  font-family: 'JosefinSans';\n  src: local('JosefinSans'), url('./assets/fonts/JosefinSans-Regular.ttf') format('truetype');\n  font-display: swap;\n}\n\nbody {\n  min-height: 100%;\n  margin: 0;\n  border: 0;\n  padding: 0;\n  font-family: 'JosefinSans', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background: #f3f4ff;\n  background-repeat: no-repeat;\n  background-attachment: fixed;\n}\n\n/* Responsividade para telas pequenas (celulares) */\n@media only screen and (max-width: 600px) {\n  body {\n      font-size: 14px;\n  }\n\n  h1 {\n      font-size: 22px;\n  }\n\n  h2 {\n      font-size: 18px;\n  }\n\n  p {\n      font-size: 12px;\n  }\n\n  /* Ajuste de largura para botões e links */\n  button, a {\n      font-size: 14px;\n      width: 100%;\n      text-align: center;\n  }\n}\n\n/* Responsividade para tablets (entre 600px e 1024px) */\n@media only screen and (max-width: 1024px) and (min-width: 601px) {\n  body {\n      font-size: 15px;\n  }\n\n  h1 {\n      font-size: 26px;\n  }\n\n  h2 {\n      font-size: 22px;\n  }\n\n  p {\n      font-size: 14px;\n  }\n\n  /* Ajuste de largura para botões e links */\n  button, a {\n      font-size: 16px;\n      width: auto;\n  }\n}\n\n/* Responsividade para telas grandes (desktop e maiores) */\n@media only screen and (min-width: 1025px) {\n  body {\n      font-size: 16px;\n  }\n\n  h1 {\n      font-size: 30px;\n  }\n\n  h2 {\n      font-size: 24px;\n  }\n\n  p {\n      font-size: 16px;\n  }\n\n  button, a {\n      font-size: 18px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
